<template>
    <div class="home">
        <div class="top">
            <h1>Welcome <span class="name">{{ user.name }}</span>!</h1>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        },
    },
};
</script>

<style lang="postcss" scoped>
.top {
    margin-bottom: 25px;
}
.name {
    display: inline-block;
    text-transform: lowercase;
    &:first-letter {
        text-transform: uppercase;
    }
}
</style>
